module.exports = __webpack_public_path__ + "static/img/aRZ_pic08.4d22705.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic08.jpg
// module id = 7rzG
// module chunks = 5